import React from "react";
import { ClientDetailsAndDocumentStep } from "../../../components/ClientDetailsAndDocumentStep";

type Props = { lockArena?: boolean };

export const InvestmentClientDetailsAndSupportingDocumentStep: React.FC<Props> = ({
  lockArena,
}) => {
  return <ClientDetailsAndDocumentStep documentType={"supporting"} lockArena={lockArena} />;
};

export default InvestmentClientDetailsAndSupportingDocumentStep;
